import { Flex,Text,View,Icon } from "@aws-amplify/ui-react";
import {
    KeitouzuItemTitle,
    KeitouzuItemBadge,
    KeitouzuItemAntenna
} from '../ui-components'


export default function KanshiKyotenMachineStateWrapper(props) {
    const KEITOUZU_TITLE_KYOKUSYA = "各局社内";
    const KEITOUZU_TITLE_OKUGAI = "屋外防水キャビネット";
    const KEITOUZU_NAME_KAISEN_1 = "回線装置 #1";
    const KEITOUZU_NAME_KAISEN_2 = "回線装置 #2";
    const KEITOUZU_NAME_NWSW_1 = "ネットワーク\nSW #1";
    const KEITOUZU_NAME_NWSW_2 = "ネットワーク\nSW #2";
    const KEITOUZU_NAME_NWSW_3 = "ネットワーク\nSW #3";
    const KEITOUZU_NAME_NWSW_4 = "ネットワーク\nSW #4";
    const KEITOUZU_NAME_KEISOKUPC_HONBAN = "計測PC\n本番機";
    const KEITOUZU_NAME_KEISOKUPC_YOBIKI = "計測PC\n予備機";
    const KEITOUZU_NAME_KANSHIPC = "監視端末";
    const KEITOUZU_NAME_GPS_1 = "GPS #1";
    const KEITOUZU_NAME_GPS_2 = "GPS #2";
    const KEITOUZU_NAME_SUPEANA_1 = "スペアナ #1";
    const KEITOUZU_NAME_SUPEANA_2 = "スペアナ #2";
    const KEITOUZU_NAME_DCDENGEN_1 = "DC電源 #1";
    const KEITOUZU_NAME_DCDENGEN_2 = "DC電源 #2";
    const KEITOUZU_NAME_DCDENGEN_3 = "DC電源 #3";
    const KEITOUZU_NAME_DCDENGEN_4 = "DC電源 #4";
    const KEITOUZU_NAME_DCDENGEN_5 = "DC電源 #5";
    const KEITOUZU_NAME_LNA = "LNA";
    const KEITOUZU_NAME_LNA_SW_1 = "LNA SW #1";
    const KEITOUZU_NAME_LNA_SW_2 = "LNA SW #2";
    const KEITOUZU_NAME_LNA_SW_3 = "LNA SW #3";
    const KEITOUZU_NAME_NOIZE_SOURCE = "ノイズソース";
    const KEITOUZU_NAME_TEMP_SENCER = "温度センサー";
    const KEITOUZU_NAME_POWER_MONITOR = "電力モニター";
    const KEITOUZU_NAME_DENGEN_A = "電源A系";
    const KEITOUZU_NAME_DENGEN_B = "電源B系";
    const KEITOUZU_NAME_RACK_TEMP = "ラック内温度";

    return (
        <>
        <View
        width="1072px"
        height="648px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        overflow="hidden"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        backgroundColor="rgba(245,245,245,1)"
        // {...getOverrideProps(overrides, "Frame 914")}
        >
            <View
            padding="0px 0px 0px 0px"
            width="974px"
            height="638px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="0px"
            left="calc(50% - 487px - 0px)"
            // {...getOverrideProps(overrides, "Keitouzu")}
            >
            <Flex
                gap="0"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                position="absolute"
                top="0px"
                left="558px"
                padding="0px 0px 0px 0px"
                // {...getOverrideProps(overrides, "Kyokusya")}
            >
                <KeitouzuItemTitle
                display="flex"
                gap="10px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                shrink="0"
                position="relative"
                borderRadius="8px 8px 0px 0px"
                padding="12px 16px 0px 16px"
                backgroundColor="rgba(255,255,255,1)"
                overrides={{
                    text: { children: KEITOUZU_TITLE_KYOKUSYA },
                }}
                // {...getOverrideProps(overrides, "Keitouzu/Item/Title508832473")}
                ></KeitouzuItemTitle>
                <View
                width="416px"
                height="612px"
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                overflow="hidden"
                shrink="0"
                position="relative"
                borderRadius="0px 8px 8px 8px"
                padding="0px 0px 0px 0px"
                backgroundColor="rgba(255,255,255,1)"
                // {...getOverrideProps(overrides, "Frame 913")}
                >
                <View
                    padding="0px 0px 0px 0px"
                    width="336px"
                    height="478px"
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="20px"
                    left="calc(50% - 168px - 0px)"
                    // {...getOverrideProps(overrides, "Right")}
                >
                    <View
                    padding="0px 0px 0px 0px"
                    width="240px"
                    height="432px"
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="28px"
                    left="47px"
                    // {...getOverrideProps(overrides, "Line508832476")}
                    >
                    <View
                        width="2px"
                        height="56px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="248px"
                        left="150px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030290"
                        // )}
                    >
                        <Icon
                        width="2px"
                        height="56px"
                        viewBox={{ minX: 0, minY: 0, width: 2, height: 56 }}
                        paths={[
                            {
                            d: "M0 2L0 0L2 0L2 2L0 2ZM0 10L0 6L2 6L2 10L0 10ZM0 18L0 14L2 14L2 18L0 18ZM0 26L0 22L2 22L2 26L0 26ZM0 34L0 30L2 30L2 34L0 34ZM0 42L0 38L2 38L2 42L0 42ZM0 50L0 46L2 46L2 50L0 50ZM0 56L0 54L2 54L2 56L0 56Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="0%"
                        bottom="0%"
                        left="0%"
                        right="0%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231806"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="80px"
                        height="80px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="0px"
                        left="1px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030272"
                        // )}
                    >
                        <Icon
                        width="88.36px"
                        height="81px"
                        viewBox={{
                            minX: 0,
                            minY: 0,
                            width: 88.36376953125,
                            height: 81,
                        }}
                        paths={[
                            {
                            d: "M80.2929 0.292893C80.6834 -0.0976311 81.3166 -0.097631 81.7071 0.292893L88.0711 6.65686C88.4616 7.04738 88.4616 7.68054 88.0711 8.07107C87.6805 8.46159 87.0474 8.46159 86.6569 8.07107L82 3.41421L82 42L2 42L2 81L0 81L3.57628e-06 40L80 40L80 3.41421L75.3432 8.07107C74.9526 8.46159 74.3195 8.46159 73.9289 8.07107C73.5384 7.68054 73.5384 7.04738 73.9289 6.65685L80.2929 0.292893Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="-1.25%"
                        bottom="0%"
                        left="-1.25%"
                        right="-9.2%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231807"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="80px"
                        height="80px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="0px"
                        right="0px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030276"
                        // )}
                    >
                        <Icon
                        width="88.36px"
                        height="81px"
                        viewBox={{
                            minX: 0,
                            minY: 0,
                            width: 88.36376953125,
                            height: 81,
                        }}
                        paths={[
                            {
                            d: "M6.65685 0.292893C7.04738 -0.097631 7.68054 -0.0976311 8.07107 0.292893L14.435 6.65685C14.8256 7.04738 14.8256 7.68054 14.435 8.07107C14.0445 8.46159 13.4113 8.46159 13.0208 8.07107L8.36396 3.41421L8.36397 40L88.364 40L88.364 81L86.364 81L86.364 42L6.36397 42L6.36396 3.41421L1.70711 8.07107C1.31658 8.46159 0.683418 8.46159 0.292893 8.07107C-0.097631 7.68054 -0.097631 7.04738 0.292893 6.65686L6.65685 0.292893Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="-1.25%"
                        bottom="0%"
                        left="-9.2%"
                        right="-1.25%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231808"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="120px"
                        height="2px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="77px"
                        left="58px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030280"
                        // )}
                    >
                        <Icon
                        width="120px"
                        height="2px"
                        viewBox={{ minX: 0, minY: 0, width: 120, height: 2 }}
                        paths={[
                            {
                            d: "M120 2L0 2L0 0L120 0L120 2Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="0%"
                        bottom="0%"
                        left="0%"
                        right="0%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231809"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="2px"
                        height="40px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="265px"
                        left="132px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030278"
                        // )}
                    >
                        <Icon
                        width="2px"
                        height="40px"
                        viewBox={{ minX: 0, minY: 0, width: 2, height: 40 }}
                        paths={[
                            {
                            d: "M0 40L0 0L2 0L2 40L0 40Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="0%"
                        bottom="0%"
                        left="0%"
                        right="0%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231810"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="2px"
                        height="352px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="80px"
                        left="0px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030284"
                        // )}
                    >
                        <Icon
                        width="2px"
                        height="352px"
                        viewBox={{ minX: 0, minY: 0, width: 2, height: 352 }}
                        paths={[
                            {
                            d: "M0 352L0 0L2 0L2 352L0 352Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="0%"
                        bottom="0%"
                        left="0%"
                        right="0%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231811"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="220px"
                        height="40px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="134px"
                        left="1px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030274"
                        // )}
                    >
                        <Icon
                        width="221px"
                        height="41px"
                        viewBox={{ minX: 0, minY: 0, width: 221, height: 41 }}
                        paths={[
                            {
                            d: "M219 2L0 2L0 1.72853e-06L221 0L221 41L219 41L219 2Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="-2.5%"
                        bottom="0%"
                        left="0%"
                        right="-0.45%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231812"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="220px"
                        height="40px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="265px"
                        left="1px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030286"
                        // )}
                    >
                        <Icon
                        width="221px"
                        height="41px"
                        viewBox={{ minX: 0, minY: 0, width: 221, height: 41 }}
                        paths={[
                            {
                            d: "M219 2L0 2L0 1.72853e-06L221 0L221 41L219 41L219 2Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="-2.5%"
                        bottom="0%"
                        left="0%"
                        right="-0.45%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231813"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="2px"
                        height="224px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="89px"
                        left="238px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030282"
                        // )}
                    >
                        <Icon
                        width="2px"
                        height="224px"
                        viewBox={{ minX: 0, minY: 0, width: 2, height: 224 }}
                        paths={[
                            {
                            d: "M0 2L0 0L2 0L2 2L0 2ZM0 10L0 6L2 6L2 10L0 10ZM0 18L0 14L2 14L2 18L0 18ZM0 26L0 22L2 22L2 26L0 26ZM0 34L0 30L2 30L2 34L0 34ZM0 42L0 38L2 38L2 42L0 42ZM0 50L0 46L2 46L2 50L0 50ZM0 58L0 54L2 54L2 58L0 58ZM0 66L0 62L2 62L2 66L0 66ZM0 74L0 70L2 70L2 74L0 74ZM0 82L0 78L2 78L2 82L0 82ZM0 90L0 86L2 86L2 90L0 90ZM0 98L0 94L2 94L2 98L0 98ZM0 106L0 102L2 102L2 106L0 106ZM0 114L0 110L2 110L2 114L0 114ZM0 122L0 118L2 118L2 122L0 122ZM0 130L0 126L2 126L2 130L0 130ZM0 138L0 134L2 134L2 138L0 138ZM0 146L0 142L2 142L2 146L0 146ZM0 154L0 150L2 150L2 154L0 154ZM0 162L0 158L2 158L2 162L0 162ZM0 170L0 166L2 166L2 170L0 170ZM0 178L0 174L2 174L2 178L0 178ZM0 186L0 182L2 182L2 186L0 186ZM0 194L0 190L2 190L2 194L0 194ZM0 202L0 198L2 198L2 202L0 202ZM0 210L0 206L2 206L2 210L0 210ZM0 218L0 214L2 214L2 218L0 218ZM0 224L0 222L2 222L2 224L0 224Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="0%"
                        bottom="0%"
                        left="0%"
                        right="0%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231814"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="220px"
                        height="56px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="118px"
                        left="19px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030288"
                        // )}
                    >
                        <Icon
                        width="221px"
                        height="57px"
                        viewBox={{ minX: 0, minY: 0, width: 221, height: 57 }}
                        paths={[
                            {
                            d: "M0 0L2.96429 0L2.96429 2L2 2L2 3L0 3L0 0ZM10.8214 2L6.89286 2L6.89286 5.96046e-08L10.8214 1.19209e-07L10.8214 2ZM18.6786 2L14.75 2L14.75 1.78814e-07L18.6786 1.78814e-07L18.6786 2ZM26.5357 2L22.6071 2L22.6071 2.38419e-07L26.5357 2.98023e-07L26.5357 2ZM34.3929 2L30.4643 2L30.4643 3.57628e-07L34.3929 3.57628e-07L34.3929 2ZM42.25 2L38.3214 2L38.3214 4.17233e-07L42.25 4.76837e-07L42.25 2ZM50.1071 2L46.1786 2L46.1786 4.76837e-07L50.1071 5.36442e-07L50.1071 2ZM57.9643 2L54.0357 2L54.0357 5.96046e-07L57.9643 6.55651e-07L57.9643 2ZM65.8214 2L61.8928 2L61.8928 6.55651e-07L65.8214 7.15256e-07L65.8214 2ZM73.6786 2L69.75 2L69.75 7.7486e-07L73.6786 8.34465e-07L73.6786 2ZM81.5357 2L77.6071 2L77.6071 8.34465e-07L81.5357 8.9407e-07L81.5357 2ZM89.3929 2L85.4643 2L85.4643 9.53674e-07L89.3929 1.01328e-06L89.3929 2ZM97.25 2L93.3214 2L93.3214 1.01328e-06L97.25 1.07288e-06L97.25 2ZM105.107 2L101.179 2L101.179 1.13249e-06L105.107 1.13249e-06L105.107 2ZM112.964 2L109.036 2L109.036 1.19209e-06L112.964 1.2517e-06L112.964 2ZM120.821 2L116.893 2L116.893 1.3113e-06L120.821 1.3113e-06L120.821 2ZM128.679 2L124.75 2L124.75 1.37091e-06L128.679 1.43051e-06L128.679 2ZM136.536 2L132.607 2L132.607 1.49012e-06L136.536 1.49012e-06L136.536 2ZM144.393 2L140.464 2L140.464 1.54972e-06L144.393 1.60933e-06L144.393 2ZM152.25 2L148.321 2L148.321 1.66893e-06L152.25 1.66893e-06L152.25 2ZM160.107 2L156.179 2L156.179 1.72853e-06L160.107 1.78814e-06L160.107 2ZM167.964 2L164.036 2L164.036 1.78814e-06L167.964 1.84774e-06L167.964 2ZM175.821 2L171.893 2L171.893 1.90735e-06L175.821 1.96695e-06L175.821 2ZM183.679 2L179.75 2L179.75 1.96695e-06L183.679 2.02656e-06L183.679 2ZM191.536 2L187.607 2L187.607 2.08616e-06L191.536 2.14577e-06L191.536 2ZM199.393 2L195.464 2L195.464 2.14577e-06L199.393 2.20537e-06L199.393 2ZM207.25 2L203.321 2L203.321 2.26498e-06L207.25 2.32458e-06L207.25 2ZM215.107 2L211.179 2L211.179 2.32458e-06L215.107 2.38419e-06L215.107 2ZM221 2L219.036 2L219.036 2.44379e-06L221 2.44379e-06L221 2ZM2 7L2 11L0 11L0 7L2 7ZM2 15L2 19L0 19L0 15L2 15ZM2 23L2 27L0 27L0 23L2 23ZM2 31L2 35L0 35L0 31L2 31ZM2 39L2 43L0 43L0 39L2 39ZM2 47L2 51L0 51L0 47L2 47ZM2 55L2 57L0 57L0 55L2 55Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="-1.79%"
                        bottom="0%"
                        left="-0.45%"
                        right="0%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231815"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="220px"
                        height="56px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="248px"
                        left="19px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030270"
                        // )}
                    >
                        <Icon
                        width="221px"
                        height="57px"
                        viewBox={{ minX: 0, minY: 0, width: 221, height: 57 }}
                        paths={[
                            {
                            d: "M0 0L2.96429 0L2.96429 2L2 2L2 3L0 3L0 0ZM10.8214 2L6.89286 2L6.89286 5.96046e-08L10.8214 1.19209e-07L10.8214 2ZM18.6786 2L14.75 2L14.75 1.78814e-07L18.6786 1.78814e-07L18.6786 2ZM26.5357 2L22.6071 2L22.6071 2.38419e-07L26.5357 2.98023e-07L26.5357 2ZM34.3929 2L30.4643 2L30.4643 3.57628e-07L34.3929 3.57628e-07L34.3929 2ZM42.25 2L38.3214 2L38.3214 4.17233e-07L42.25 4.76837e-07L42.25 2ZM50.1071 2L46.1786 2L46.1786 4.76837e-07L50.1071 5.36442e-07L50.1071 2ZM57.9643 2L54.0357 2L54.0357 5.96046e-07L57.9643 6.55651e-07L57.9643 2ZM65.8214 2L61.8928 2L61.8928 6.55651e-07L65.8214 7.15256e-07L65.8214 2ZM73.6786 2L69.75 2L69.75 7.7486e-07L73.6786 8.34465e-07L73.6786 2ZM81.5357 2L77.6071 2L77.6071 8.34465e-07L81.5357 8.9407e-07L81.5357 2ZM89.3929 2L85.4643 2L85.4643 9.53674e-07L89.3929 1.01328e-06L89.3929 2ZM97.25 2L93.3214 2L93.3214 1.01328e-06L97.25 1.07288e-06L97.25 2ZM105.107 2L101.179 2L101.179 1.13249e-06L105.107 1.13249e-06L105.107 2ZM112.964 2L109.036 2L109.036 1.19209e-06L112.964 1.2517e-06L112.964 2ZM120.821 2L116.893 2L116.893 1.3113e-06L120.821 1.3113e-06L120.821 2ZM128.679 2L124.75 2L124.75 1.37091e-06L128.679 1.43051e-06L128.679 2ZM136.536 2L132.607 2L132.607 1.49012e-06L136.536 1.49012e-06L136.536 2ZM144.393 2L140.464 2L140.464 1.54972e-06L144.393 1.60933e-06L144.393 2ZM152.25 2L148.321 2L148.321 1.66893e-06L152.25 1.66893e-06L152.25 2ZM160.107 2L156.179 2L156.179 1.72853e-06L160.107 1.78814e-06L160.107 2ZM167.964 2L164.036 2L164.036 1.78814e-06L167.964 1.84774e-06L167.964 2ZM175.821 2L171.893 2L171.893 1.90735e-06L175.821 1.96695e-06L175.821 2ZM183.679 2L179.75 2L179.75 1.96695e-06L183.679 2.02656e-06L183.679 2ZM191.536 2L187.607 2L187.607 2.08616e-06L191.536 2.14577e-06L191.536 2ZM199.393 2L195.464 2L195.464 2.14577e-06L199.393 2.20537e-06L199.393 2ZM207.25 2L203.321 2L203.321 2.26498e-06L207.25 2.32458e-06L207.25 2ZM215.107 2L211.179 2L211.179 2.32458e-06L215.107 2.38419e-06L215.107 2ZM221 2L219.036 2L219.036 2.44379e-06L221 2.44379e-06L221 2ZM2 7L2 11L0 11L0 7L2 7ZM2 15L2 19L0 19L0 15L2 15ZM2 23L2 27L0 27L0 23L2 23ZM2 31L2 35L0 35L0 31L2 31ZM2 39L2 43L0 43L0 39L2 39ZM2 47L2 51L0 51L0 47L2 47ZM2 55L2 57L0 57L0 55L2 55Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="-1.79%"
                        bottom="0%"
                        left="-0.45%"
                        right="0%"
                        // {...getOverrideProps(
                            // overrides,
                            // "Vector (Stroke)509231816"
                        // )}
                        ></Icon>
                    </View>
                    </View>
                    <View
                    padding="0px 0px 0px 0px"
                    width="336px"
                    height="478px"
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="0px"
                    left="0px"
                    // {...getOverrideProps(overrides, "Badge508832488")}
                    >
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="202px"
                        left="0px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_NWSW_1},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832489"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="89px"
                        left="0px"
                        borderRadius="4px"
                        type="White"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_KAISEN_1},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832490"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="332px"
                        left="149px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_KEISOKUPC_HONBAN},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832491"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="332px"
                        left="237px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_KEISOKUPC_YOBIKI},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832492"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="445px"
                        left="0px"
                        borderRadius="4px"
                        type="White"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_KANSHIPC},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832493"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="89px"
                        left="218px"
                        borderRadius="4px"
                        type="White"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_KAISEN_2},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832494"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="202px"
                        left="216px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_NWSW_2},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832495"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="332px"
                        left="0px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_NWSW_3},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832496"
                        // )}
                    ></KeitouzuItemBadge>
                    <Text
                        fontFamily="Noto Sans"
                        fontSize="14px"
                        fontWeight="700"
                        color="rgba(53,56,59,1)"
                        lineHeight="16.80000114440918px"
                        textAlign="left"
                        display="block"
                        direction="column"
                        justifyContent="unset"
                        letterSpacing="0.55px"
                        width="120px"
                        height="24px"
                        gap="unset"
                        alignItems="unset"
                        position="absolute"
                        top="0%"
                        bottom="94.98%"
                        left="32.14%"
                        right="32.14%"
                        padding="0px 0px 0px 0px"
                        whiteSpace="pre-wrap"
                        children="インターネットへ"
                        // {...getOverrideProps(overrides, "text")}
                    ></Text>
                    </View>
                </View>
                </View>
            </Flex>
            <Flex
                gap="0"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                position="absolute"
                top="0px"
                left="0px"
                padding="0px 0px 0px 0px"
                // {...getOverrideProps(overrides, "Cabinet")}
            >
                <KeitouzuItemTitle
                display="flex"
                gap="10px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                shrink="0"
                position="relative"
                borderRadius="8px 8px 0px 0px"
                padding="12px 16px 0px 16px"
                backgroundColor="rgba(255,255,255,1)"
                overrides={{
                    text: { children: KEITOUZU_TITLE_OKUGAI },
                }}
                // {...getOverrideProps(overrides, "Keitouzu/Item/Title508832434")}
                ></KeitouzuItemTitle>
                <View
                width="478px"
                height="612px"
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                overflow="hidden"
                shrink="0"
                position="relative"
                borderRadius="0px 8px 8px 8px"
                padding="0px 0px 0px 0px"
                backgroundColor="rgba(255,255,255,1)"
                // {...getOverrideProps(overrides, "Frame 912")}
                >
                <View
                    padding="0px 0px 0px 0px"
                    width="398px"
                    height="572px"
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="calc(50% - 286px - 0px)"
                    left="calc(50% - 199px - 0px)"
                    // {...getOverrideProps(overrides, "Left")}
                >
                    <View
                    padding="0px 0px 0px 0px"
                    width="324px"
                    height="457px"
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="50px"
                    left="14px"
                    // {...getOverrideProps(overrides, "Line508832437")}
                    >
                    <View
                        width="160px"
                        height="457px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="0px"
                        left="164px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030307"
                        // )}
                    >
                        <Icon
                        width="161px"
                        height="458px"
                        viewBox={{ minX: 0, minY: 0, width: 161, height: 458 }}
                        paths={[
                            {
                            d: "M159 456L159 0L161 0L161 458L0 458L0 456L159 456Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="0%"
                        bottom="-0.22%"
                        left="0%"
                        right="-0.62%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231773"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="323px"
                        height="112px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="42px"
                        left="1px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030309"
                        // )}
                    >
                        <Icon
                        width="324px"
                        height="113px"
                        viewBox={{ minX: 0, minY: 0, width: 324, height: 113 }}
                        paths={[
                            {
                            d: "M0 0L2 0L2 111L324 111L324 113L0 113L0 0Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="0%"
                        bottom="-0.89%"
                        left="-0.31%"
                        right="0%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231774"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="323px"
                        height="2px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="55px"
                        left="0px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030315"
                        // )}
                    >
                        <Icon
                        width="323px"
                        height="2px"
                        viewBox={{ minX: 0, minY: 0, width: 323, height: 2 }}
                        paths={[
                            {
                            d: "M323 2L0 2L0 0L323 0L323 2Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="0%"
                        bottom="0%"
                        left="0%"
                        right="0%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231775"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="2px"
                        height="40px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="16px"
                        left="184px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030305"
                        // )}
                    >
                        <Icon
                        width="2px"
                        height="40px"
                        viewBox={{ minX: 0, minY: 0, width: 2, height: 40 }}
                        paths={[
                            {
                            d: "M0 40L0 0L2 0L2 40L0 40Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="0%"
                        bottom="0%"
                        left="0%"
                        right="0%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231776"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="2px"
                        height="40px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="114px"
                        left="184px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030313"
                        // )}
                    >
                        <Icon
                        width="2px"
                        height="40px"
                        viewBox={{ minX: 0, minY: 0, width: 2, height: 40 }}
                        paths={[
                            {
                            d: "M0 40L0 0L2 0L2 40L0 40Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="0%"
                        bottom="0%"
                        left="0%"
                        right="0%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231777"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="320px"
                        height="2px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="202px"
                        left="4px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030317"
                        // )}
                    >
                        <Icon
                        width="320px"
                        height="2px"
                        viewBox={{ minX: 0, minY: 0, width: 320, height: 2 }}
                        paths={[
                            {
                            d: "M320 2L0 2L0 0L320 0L320 2Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="0%"
                        bottom="0%"
                        left="0%"
                        right="0%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231778"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="320px"
                        height="2px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="243px"
                        left="4px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030319"
                        // )}
                    >
                        <Icon
                        width="320px"
                        height="2px"
                        viewBox={{ minX: 0, minY: 0, width: 320, height: 2 }}
                        paths={[
                            {
                            d: "M320 2L0 2L0 0L320 0L320 2Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="0%"
                        bottom="0%"
                        left="0%"
                        right="0%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231779"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="320px"
                        height="2px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="284px"
                        left="4px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030321"
                        // )}
                    >
                        <Icon
                        width="320px"
                        height="2px"
                        viewBox={{ minX: 0, minY: 0, width: 320, height: 2 }}
                        paths={[
                            {
                            d: "M320 2L0 2L0 0L320 0L320 2Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="0%"
                        bottom="0%"
                        left="0%"
                        right="0%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231780"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="320px"
                        height="2px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="325px"
                        left="4px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030311"
                        // )}
                    >
                        <Icon
                        width="320px"
                        height="2px"
                        viewBox={{ minX: 0, minY: 0, width: 320, height: 2 }}
                        paths={[
                            {
                            d: "M320 2L0 2L0 0L320 0L320 2Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="0%"
                        bottom="0%"
                        left="0%"
                        right="0%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231781"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="320px"
                        height="2px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="366px"
                        left="4px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030323"
                        // )}
                    >
                        <Icon
                        width="320px"
                        height="2px"
                        viewBox={{ minX: 0, minY: 0, width: 320, height: 2 }}
                        paths={[
                            {
                            d: "M320 2L0 2L0 0L320 0L320 2Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="0%"
                        bottom="0%"
                        left="0%"
                        right="0%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231782"
                        // )}
                        ></Icon>
                    </View>
                    <View
                        width="160px"
                        height="2px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="415px"
                        left="164px"
                        padding="0px 0px 0px 0px"
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Line509030303"
                        // )}
                    >
                        <Icon
                        width="160px"
                        height="2px"
                        viewBox={{ minX: 0, minY: 0, width: 160, height: 2 }}
                        paths={[
                            {
                            d: "M160 2L0 2L0 0L160 0L160 2Z",
                            fill: "rgba(100,100,100,1)",
                            fillRule: "evenodd",
                            },
                        ]}
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        position="absolute"
                        top="0%"
                        bottom="0%"
                        left="0%"
                        right="0%"
                        // {...getOverrideProps(
                        //     overrides,
                        //     "Vector (Stroke)509231783"
                        // )}
                        ></Icon>
                    </View>
                    </View>
                    <View
                    padding="0px 0px 0px 0px"
                    width="398px"
                    height="572px"
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="0px"
                    left="0px"
                    // {...getOverrideProps(overrides, "Badge508832449")}
                    >
                    <KeitouzuItemAntenna
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        position="absolute"
                        top="0px"
                        left="0px"
                        border="2px SOLID rgba(100,100,100,1)"
                        borderRadius="4px"
                        padding="14px 6px 14px 6px"
                        backgroundColor="rgba(255,255,255,1)"
                        // {...getOverrideProps(overrides, "Keitouzu/Item/Antenna")}
                    ></KeitouzuItemAntenna>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="0px"
                        left="278px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_NWSW_4},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832451"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="236px"
                        left="143px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_DCDENGEN_1},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832452"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="236px"
                        left="0px"
                        borderRadius="4px"
                        type="White"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_LNA},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832453"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="40px"
                        left="143px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_GPS_1},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832454"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="277px"
                        left="143px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_DCDENGEN_2},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832455"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="277px"
                        left="0px"
                        borderRadius="4px"
                        type="White"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_LNA_SW_1},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832456"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="318px"
                        left="143px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_DCDENGEN_3},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832457"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="318px"
                        left="0px"
                        borderRadius="4px"
                        type="White"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_LNA_SW_2},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832458"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="359px"
                        left="143px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_DCDENGEN_4},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832459"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="359px"
                        left="0px"
                        borderRadius="4px"
                        type="White"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_LNA_SW_3},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832460"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="400px"
                        left="143px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_DCDENGEN_5},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832461"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="400px"
                        left="0px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_NOIZE_SOURCE},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832462"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="138px"
                        left="143px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_GPS_2},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832463"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="187px"
                        left="143px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_SUPEANA_2},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832464"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="449px"
                        left="143px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_TEMP_SENCER},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832465"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="490px"
                        left="143px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_POWER_MONITOR},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832466"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="539px"
                        left="41px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_DENGEN_A},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832467"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="539px"
                        left="143px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_DENGEN_B},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832468"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="539px"
                        left="245px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_RACK_TEMP},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832469"
                        // )}
                    ></KeitouzuItemBadge>
                    <KeitouzuItemBadge
                        display="flex"
                        gap="10px"
                        direction="column"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        position="absolute"
                        top="89px"
                        left="143px"
                        borderRadius="4px"
                        padding="8px 16px 8px 16px"
                        backgroundColor="rgba(38,193,147,1)"
                        type="Default"
                        label="False"
                        overrides={{
                            text: {children: KEITOUZU_NAME_SUPEANA_1},
                        }}
                        // {...getOverrideProps(
                        // overrides,
                        // "Keitouzu/Item/Badge508832471"
                        // )}
                    ></KeitouzuItemBadge>
                    </View>
                </View>
                </View>
            </Flex>
            <View
                width="160px"
                height="437px"
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="71px"
                left="438px"
                padding="0px 0px 0px 0px"
                // {...getOverrideProps(overrides, "Keitouzu/Item/Line508832678")}
            >
                <Icon
                width="160px"
                height="439px"
                viewBox={{ minX: 0, minY: 0, width: 160, height: 439 }}
                paths={[
                    {
                    d: "M0 0L81 0L81 437L160 437L160 439L79 439L79 2L0 2L0 0Z",
                    fill: "rgba(100,100,100,1)",
                    fillRule: "evenodd",
                    },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="-0.23%"
                bottom="-0.23%"
                left="0%"
                right="0%"
                // {...getOverrideProps(overrides, "Vector (Stroke)508832680")}
                ></Icon>
            </View>
            </View>
        </View>
        </>
    );
}